module.exports = __webpack_public_path__ + "img/229.479673ed.png";